
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 42 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.641 28.305c-.138-.066-.292-.052-.437-.087-.62-.151-1.198-.377-1.62-.884-.445-.537-.525-1.155-.293-1.786.227-.616.75-.941 1.371-1.04.96-.151 1.682.28 2.034 1.156.12.3.238.601.476.834.328.317.725.279.963-.11a1.68 1.68 0 00.238-.887c.002-5.119.002-10.237 0-15.355a.598.598 0 00-.601-.605c-.284-.006-.57 0-.853 0a.944.944 0 01-.915-.757.919.919 0 01.625-1.04 1.49 1.49 0 01.488-.06h7.99c.447 0 .658-.148.818-.57.16-.424.59-.698 1.1-.7h12.59c.297 0 .297 0 .298.297V8.1c0 .249 0 .25-.259.25h-3.291c-.555 0-.853.301-.853.857v11.625c0 .505-.182.892-.627 1.174-1.25.794-2.487 1.61-3.727 2.417-.082.055-.17.102-.261.139-.509.195-.976-.106-1.015-.65-.005-.072 0-.145 0-.218V9.47c0-.119-.008-.237-.024-.355-.068-.513-.344-.76-.862-.765-.62-.004-1.242 0-1.863 0-.424 0-.61.136-.756.531a.998.998 0 01-.945.658c-.192.005-.383 0-.575 0a.59.59 0 00-.61.595v11.724a3.154 3.154 0 01-.555 1.848c-.282.402-.67.69-1.07.959-1.31.883-2.632 1.751-3.936 2.644-.656.45-1.348.802-2.135.94-.127.022-.262-.019-.381.055l-.527.001zM31.704 13.522c0-2.281-.001-4.563-.004-6.845 0-.188.045-.243.238-.242 1.738.007 3.476.007 5.215 0 .18 0 .216.051.216.221-.005 3.617-.007 7.234-.005 10.852 0 .499-.178.894-.625 1.178-1.262.802-2.51 1.625-3.763 2.439a.913.913 0 01-.422.159c-.486.04-.77-.215-.84-.76a1.855 1.855 0 01-.01-.239v-6.763zM34.52 3.308h2.141a.892.892 0 01.912.834c.036.532-.279.928-.793.998a2.22 2.22 0 01-.295.023h-3.96c-.342 0-.656-.07-.865-.38-.21-.31-.247-.64-.08-.973a.848.848 0 01.8-.502h2.14z","fill":"#fff"}})])
          )
        }
      }
    